import { Component } from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';

const DEFAULT_COLOR = '#94abbb';

const PopOverElement = styled.div`
  position: absolute;
  display: ${(props: any) => (props.isOpen ? 'flex' : 'none')};
  margin-top: 16px;
  background-color: white;
  z-index: 2;
  /*box-shadow: 11px 28px 79px -12px rgba(0, 0, 0, 0.3);*/
  box-shadow: 8px 8px 20px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  transition: all 0.2s ease-in;
  cursor: default;

  &&:before {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    left: 10px;
    border-bottom: 16px solid ${props => props.color || DEFAULT_COLOR};
    content: '';
    position: absolute;
    top: -16px;
  }
`;

const BarElement = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.color || DEFAULT_COLOR};
  color: white;
  width: 40px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
`;
const ContentElement = styled.div`
  padding: 20px;
`;

export interface IProps {
  isOpen?: boolean;
  icon?: string;
  color?: any;
  children?: any;
}

export class PopOver extends Component<IProps> {
  public render() {
    return (
      <PopOverElement {...this.props}>
        <BarElement {...this.props}>{this.props.icon && <Icon icon={this.props.icon} />}</BarElement>
        <ContentElement>{this.props.children}</ContentElement>
      </PopOverElement>
    );
  }
}
